import triggerTracking from '@blueprint/tracking';

export const trackOpen = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'snh_overlay',
        eventAction: 'impression',
        eventLabel: 'banner_shown',
        eventNonInteraction: true
    });
};

export const trackClose = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'snh_overlay',
        eventAction: 'click',
        eventLabel: 'close',
        eventNonInteraction: true
    });
};
